import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label', 'input'];

  onEnter(event) {
    if (event.code !== 'Enter' && event.code !== 'Space') return;

    event.preventDefault();

    if (!this.isFocused()) return;
    this.selectFiles();
  }

  isFocused() {
    return this.labelTarget === document.activeElement;
  }

  selectFiles() {
    this.inputTarget.click();
  }

  submit() {
    this.element.requestSubmit();
  }
}
